export default function _of(x) {
  return [x];
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_of.js
// module id = 1810
// module chunks = 1